import {Dictionary} from 'lodash'
import {CheckoutErrorCode} from '../../_gql-types/global'


export const checkoutErrorCodeMap: Dictionary<string> = {
  // BILLING_ADDRESS_NOT_SET: 'billing_address_not_set',
  // CHECKOUT_NOT_FULLY_PAID: 'checkout_not_fully_paid',
  // GRAPHQL_ERROR: 'Óþekkt villa kom upp',
  PRODUCT_NOT_PUBLISHED: 'Vara hefur ekki verið gefin út',
  PRODUCT_UNAVAILABLE_FOR_PURCHASE: 'Vara er tímabundið ekki í sölu',
  INSUFFICIENT_STOCK: 'Lagarstaða vöru er lægri en umbeðið magn',
  // INVALID: 'invalid',
  // INVALID_SHIPPING_METHOD: 'invalid_shipping_method',
  // NOT_FOUND: 'not_found',
  // PAYMENT_ERROR: 'payment_error',
  QUANTITY_GREATER_THAN_LIMIT: 'Umbeðið magn af vöru er of hátt',
  REQUIRED: 'Þennan reit þarf að fylla út',
  SHIPPING_ADDRESS_NOT_SET: 'Heimilisfang óskilgreint',
  // SHIPPING_METHOD_NOT_APPLICABLE: 'shipping_method_not_applicable',
  // SHIPPING_METHOD_NOT_SET: 'shipping_method_not_set',
  // SHIPPING_NOT_REQUIRED: 'shipping_not_required',
  // TAX_ERROR: 'tax_error',
  // UNIQUE: 'unique',
  // VOUCHER_NOT_APPLICABLE: 'voucher_not_applicable',
  ZERO_QUANTITY: 'Engar vörur í pöntun',
}

export const checkoutErrorDefaultMessage = 'Óþekkt villa kom upp'

export function getCheckoutErrorMessage(code: CheckoutErrorCode) {
  return checkoutErrorCodeMap[code] || checkoutErrorDefaultMessage
}
